import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Button,
} from '../../components/index';

class UploadDragDrop extends Component {
  constructor(props) {
    super(props);
    this.fileInputRef = React.createRef();
    this.state = {
      dragActive: false,
      uploadProgress: 0,
    };
  }

  simulateProgress = () => {
    this.setState({
      uploadProgress: 0,
    });

    let progress = 0;

    const interval = setInterval(() => {
      progress += 10;

      if (progress >= 100) {
        progress = 100;
        clearInterval(interval);
      }

      this.setState({
        uploadProgress: progress,
      });
    }, 80);
  }

  handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (
      e.type === 'dragenter'
      || e.type === 'dragover'
    ) {
      this.setState({
        dragActive: true,
      });
    } else if (e.type === 'dragleave') {
      this.setState({
        dragActive: false,
      });
    }
  }

  handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({
      dragActive: false,
    });

    if (
      e.dataTransfer.files
      && e.dataTransfer.files.length > 0
    ) {
      this.processFiles(Array.from(e.dataTransfer.files));
    }
  }

  handleChangeFile = (files) => {
    const arquivos = Array.isArray(files)
      ? files
      : Array.from(files);

    this.processFiles(arquivos);
  }

  removeFile = (index) => {
    const {
      files,
      onChange,
      onSelect,
    } = this.props;

    const novaLista =
      files.filter((_, i) => i !== index);

    onChange(novaLista);

    // avisa o componente pai que removeu o arquivo
    if (onSelect) {
      onSelect(null);
    }

    // limpa o input para permitir selecionar o mesmo arquivo novamente
    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = '';
    }
  }

  processFiles = (files) => {
    const {
      accept,
      multiple,
      files: currentFiles,
      onChange,
      onSelect,
    } = this.props;

    let arquivosFiltrados = files;

    // valida extensões permitidas
    if (accept) {
      const tiposAceitos = accept
        .split(',')
        .map(tipo => tipo.trim().toLowerCase());

      arquivosFiltrados = files.filter((file) => {
        const nomeArquivo =
          file.name.toLowerCase();

        const mimeType =
          file.type.toLowerCase();

        return tiposAceitos.some((tipoAceito) => {
          // ex: .pdf
          if (tipoAceito.startsWith('.')) {
            return nomeArquivo.endsWith(tipoAceito);
          }

          // ex: application/pdf
          return mimeType === tipoAceito;
        });
      });
    }

    let novaLista = [];

    if (multiple) {
      // múltiplos arquivos
      // evita duplicados
      const arquivosExistentes =
        currentFiles || [];

      const arquivosNovos =
        arquivosFiltrados.filter(file =>
          !arquivosExistentes.some(existente => existente.name === file.name && existente.lastModified === file.lastModified));
      novaLista = [
        ...arquivosExistentes,
        ...arquivosNovos,
      ];
    } else {
      // apenas um arquivo
      novaLista =
        arquivosFiltrados.slice(0, 1);
    }

    onChange(novaLista);

    if (onSelect && novaLista.length > 0) {
      onSelect(multiple ? novaLista : novaLista[0]);
    }

    // só exibe progresso se houver arquivo válido
    if (arquivosFiltrados.length > 0) {
      this.simulateProgress();
    }
  }

  renderProgressBar = () => {
    const {
      uploading,
      progress,
    } = this.props;

    if (!uploading) {
      return null;
    }

    return (
      <div
        style={{
          marginTop: 12,
        }}
      >
        <div
          style={{
            width: '100%',
            height: 8,
            background: '#e0e0e0',
            borderRadius: 4,
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              width: `${progress}%`,
              height: '100%',
              background: '#1976d2',
              transition: 'width 0.3s ease',
            }}
          />
        </div>

        <div
          style={{
            marginTop: 6,
            fontSize: 12,
            color: '#666',
            textAlign: 'right',
          }}
        >
          {progress}%
        </div>
      </div>
    );
  }

  render() {
    const {
      files,
      multiple,
      accept,
      textoPrincipal,
      textoSecundario,
      minHeight,
      largura,
      disabled,
    } = this.props;

    return (
      <div className="row">
        <div className={`col-xs-${largura}`}>
          <div
            onDragEnter={!disabled ? this.handleDrag : undefined}
            onDragLeave={!disabled ? this.handleDrag : undefined}
            onDragOver={!disabled ? this.handleDrag : undefined}
            onDrop={!disabled ? this.handleDrop : undefined}
            style={{
              position: 'relative',
              border: this.state.dragActive
                ? '2px dashed #1976d2'
                : '2px dashed #ccc',

              width: '100%',
              boxSizing: 'border-box',
              borderRadius: 8,
              padding: files.length > 0 ? '8px 12px 4px 12px' : 12,
              textAlign: 'center',
              background:
                this.state.dragActive
                  ? '#f5f9ff'
                  : '#fff',

              transition: 'all 0.2s ease',
              minHeight,
              cursor: disabled ? 'not-allowed' : 'pointer',
              opacity: disabled ? 0.6 : 1,
              marginBottom: 8,
            }}
          >
            <input
              ref={this.fileInputRef}
              type="file"
              accept={accept || '.pdf'}
              multiple={multiple}
              onChange={e => this.handleChangeFile(Array.from(e.target.files))}
              onClick={e => e.stopPropagation()}
              disabled={disabled}
              style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                opacity: 0,
                top: 0,
                left: 0,
                cursor: 'pointer',
                zIndex: 1,
                pointerEvents: disabled ? 'none' : 'auto',
              }}
            />

            {files.length === 0 && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  minHeight: 40,
                }}
              >
                <div
                  style={{
                    fontSize: 16,
                    marginBottom: 8,
                    color: '#546E7A',
                  }}
                >
                  {textoPrincipal}
                </div>

                <div
                  style={{
                    fontSize: 13,
                    color: '#546E7A',
                  }}
                >
                  {textoSecundario}
                </div>
              </div>
            )}

            {this.state.uploadProgress > 0
            && this.state.uploadProgress < 100 && (
              <div
                style={{
                  width: '100%',
                  marginTop: 12,
                  marginBottom: 12,
                }}
              >
                <div
                  style={{
                    height: 8,
                    background: '#e0e0e0',
                    borderRadius: 4,
                    overflow: 'hidden',
                  }}
                >
                  <div
                    style={{
                      width: `${this.state.uploadProgress}%`,
                      height: '100%',
                      background: '#1976d2',
                      transition: 'width 0.1s linear',
                    }}
                  />
                </div>

                <div
                  style={{
                    marginTop: 4,
                    fontSize: 12,
                    color: '#666',
                  }}
                >
                  Enviando...
                  {' '}
                  {this.state.uploadProgress}
                  %
                </div>
              </div>
            )}

            {files.length > 0 && (
              <div
                style={{
                  marginTop: files.length > 0 ? 6 : 20,
                  textAlign: 'left',
                  position: 'relative',
                  zIndex: 2,
                  maxHeight: 320,
                  overflowY: 'auto',
                  overflowX: 'hidden',
                  paddingRight: 4,
                  scrollbarWidth: 'thin',
                }}
              >
                {files.map((file, index) => (
                  <div
                    key={`${file.name}-${file.lastModified}`}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginBottom: 8,
                      padding: '2px 8px',
                      minHeight: 36,
                      background: '#f5f5f5',
                      borderRadius: 4,
                    }}
                  >
                    <span>
                      {file.name}
                    </span>

                    <Button
                      mini
                      icon="ico-cancel"
                      className="dtp-inverse"
                      hint="Remover arquivo"
                      onClick={() => this.removeFile(index)}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

UploadDragDrop.propTypes = {
  files: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    size: PropTypes.number,
    type: PropTypes.string,
    lastModified: PropTypes.number,
  })),
  onChange: PropTypes.func.isRequired,
  onSelect: PropTypes.func,
  multiple: PropTypes.bool,
  accept: PropTypes.string,
  textoPrincipal: PropTypes.string,
  textoSecundario: PropTypes.string,
  minHeight: PropTypes.number,
  progress: PropTypes.number,
  uploading: PropTypes.bool,
  largura: PropTypes.string,
  disabled: PropTypes.bool,
};

UploadDragDrop.defaultProps = {
  files: [],
  multiple: false,
  accept: '.pdf',
  textoPrincipal: 'Arraste o arquivo aqui',
  textoSecundario: 'ou clique para selecionar',
  minHeight: 110,
  progress: 0,
  uploading: false,
  largura: 12,
  onSelect: null,
  disabled: false,
};

export default UploadDragDrop;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/UploadDragDrop.jsx